/**
 * 封装axios，增加request拦截器，将每次请求的header增加token
 * 增加response拦截器，非正常返回提示错误消息和session过期提示重新登录
 */
import axios from 'axios'
import {getToken} from '@/utils/token'
import store from "@/store" // 此处使用store，不能使用usestore
import Qs from 'qs'
import {showToast} from "@/utils/toast";

// 创建axios实例

const $axios = axios.create({
  headers: {
    'Content-Type': 'application/json; charset=utf-8',
    'Access-Control-Allow-Origin-Type':"*",
  },
  responseType: "application/json",
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 30 * 1000,
  traditional:true
})

// request拦截器
$axios.interceptors.request.use(
  config => {
    if(config.method === 'get'){
      if(config.data){
        const query = Qs.stringify(config.data, { indices: false })
        config.url = `${config.url}?${query}`
      }
    }
    if(config.method === "post"){
// config.data = Qs.stringify(config.data)
    }
    if (getToken()) {
        // console.log(getToken())
      config.headers.Authorization = `Bearer ${getToken()}`
    } else {
      config.headers['Authorization'] = ""
    }
    // 处理头部
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// response拦截器
$axios.interceptors.response.use(
  response => {
    if(response.status===200){
      if(response.data){
          try {
              response.data = JSON.parse(response.data)

          }catch (e) {
              response.data = {err_code:-1,err_msg:response.data ||""}
          }

        if(response.data.err_code===401){
            showToast("warning",'您的账号使用受限') // todo
            store.dispatch('loginModel/loginOut')
            // return Promise.resolve({err_code:401,err_msg:"请登录您的账号"})
        }
          return Promise.resolve(response.data)
      }else{
          return Promise.resolve({})
      }
      // return Promise.resolve(response.data)

    }else{
      // showToast.error('请求出错')
      // return Promise.reject( "请求出错")
        return Promise.resolve({err_code:response.status,err_msg:response.message})
    }
  },
  error => {
      if(error.status===401){
          showToast("warning",'您的账号使用受限') // todo
          store.dispatch('loginModel/loginOut')
      }
    // return Promise.reject(error || "请求出错")
      return Promise.resolve({err_code:error.status,err_msg:error.message})
  }
)




export default $axios
